import { render } from "./QRCodeGeneratorPage.vue?vue&type=template&id=f4dd1580&scoped=true"
import script from "./QRCodeGeneratorPage.vue?vue&type=script&lang=js"
export * from "./QRCodeGeneratorPage.vue?vue&type=script&lang=js"

import "./QRCodeGeneratorPage.vue?vue&type=style&index=0&id=f4dd1580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4dd1580"]])

export default __exports__